import React from "react";
import { Container } from "@mui/material";
import { Toolbar } from "./Toolbar";

interface PageContainerProps {
  children: React.ReactNode;
}

export function PageContainer({ children }: PageContainerProps) {
  return (
    <Container
      sx={{ minHeight: "100vh" }}
      maxWidth={false}
      disableGutters={true}
    >
      <Toolbar />
      {children}
    </Container>
  );
}
